import { WifiSvg } from 'components/svg.components/WifiSvg';
import { useAsync } from 'hooks/useAsync';
import { gwService } from 'services/gw.service';

export const WifiSignalIcon = () => {
  const { value: wifiList } = useAsync(() => gwService.getWifiList(), { interval: 5000 });
  const signal = wifiList?.find((wifi) => wifi.connected)?.signal ?? -1;
  return <WifiSvg signalStrength={signal} theme="bright" size="medium" />;
};
